import { RouteItem } from '@eastcoal/router/types/route'

import { ORDER_RECORD_PAGE_PATH } from './constants/path'

export const orderRecordRoute: RouteItem = {
  title: '操作记录',
  path: ORDER_RECORD_PAGE_PATH,
  Component: () => import('./index')
}
